<template>
  <div class="section-header">
    <span class="section-label">{{ label }}</span>
    <span v-if="meta" class="section-meta">{{ meta }}</span>
  </div>
</template>

<script setup>
defineProps({
  label: { type: String, required: true },
  meta:  { type: String, default: null },
})
</script>

<style scoped>
.section-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 14px;
}

.section-label {
  font-family: var(--font-mono);
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 1.2px;
  text-transform: uppercase;
  color: rgba(232, 230, 227, 0.45);
}

.section-meta {
  font-family: var(--font-mono);
  font-size: 10px;
  color: rgba(232, 230, 227, 0.25);
}
</style>
